import { navigateToConsoleSubscriptions as redirectToConsoleSubscriptions } from '~/utils/navigateToConsoleSubscriptions'

export default {
  methods: {
    navigateToConsoleSubscriptions() {
      redirectToConsoleSubscriptions()
    }
  }
}
